import { ContenidoStatus } from './../../../../../common/contenido';
import { Revista, Contenido } from 'src/common/contenido';import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { RevistaActions, RevistaPageRequested, RevistaActionTypes } from './revista.actions';

export interface RevistaState extends EntityState<Revista> {
	ready: boolean;
	nextPageNum: number;
	pageSize: number;
	morePagesToLoad: boolean;
	status: ContenidoStatus;
	cleared: boolean;
}

export const revistaAdapter: EntityAdapter<Revista> = createEntityAdapter<Revista>();

const initialRevistaState: RevistaState = revistaAdapter.getInitialState({
	ready: true,
	nextPageNum: 0,
	pageSize: 5,
	morePagesToLoad: true,
	status: null,
	cleared: false
});

export function revistaReducer( state: RevistaState = initialRevistaState, action: RevistaActions ): RevistaState {
	let payload;
	let status: ContenidoStatus;

	switch( action.type ) {
		case RevistaActionTypes.RevistaPageRequested:
			return { ...state, cleared: false, ready: false };
		case RevistaActionTypes.RevistaPageLoaded:
			payload = action["payload"];
			let cleared: boolean = payload["cleared"];
			status = payload["status"];
			let nextPageNum: number = payload["nextPageNum"];
			let revista: Revista[] = payload["revista"];

			if( cleared )
				state = revistaAdapter.removeAll( state );

			return revistaAdapter.addMany( revista, {
				...state,
				ready: true,
				nextPageNum,
				status,
				cleared,
				morePagesToLoad: status.qty - state.ids.length - revista.length > 0
			});
		case RevistaActionTypes.RevistaPageCancelled:
			payload = action["payload"];
			status = payload["status"];

			// Si status == null => hubo un problema con el status, dejo el state como está			
			if( status != null && status.qty == 0 ) {
				state = revistaAdapter.removeAll( state );
				state = { ...state, ready: true, cleared: false, status, morePagesToLoad: false };
			}

			return { ...state, ready: true };
		case RevistaActionTypes.RevistaPageRight:
			return { ...state, ready: true, cleared: false };
		default:
			return state;
	}
};

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = revistaAdapter.getSelectors();